import React from "react";
import styles from "../tasks/OffSiteTasks.module.css";

export default function OffSiteStockingTasks() {
    return <div className={styles.Title}>Stocking</div>;
}
